import { Grid } from "@mui/material"
import { Link } from "react-router-dom"
import DS from "./img/BS.jpg"
import CM_Unity from "./img/CM_Unity.jpg"
import FE from "./img/FE.jpg"
import MC from "./img/MC.jpg"
import PF from "./img/PF.jpg"
import RT from "./img/RT.png"
import SC from "./img/SC.jpg"
import TOH from "./img/TOH2.png"

const GamesList = () => (
    <Grid
        container
        spacing={2}
        sx={{
            width: "75%",
            margin: "auto"
        }}>
        <Grid size={3}>
            <Link to="/cm">
                <div className="img-container">
                    <img
                        src={CM_Unity}
                        alt="Clockmaker Unity"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={3}>
            <Link to="/toh">
                <div className="img-container">
                    <img
                        src={TOH}
                        alt="Train of Hope"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={3}>
            <Link to="/mc">
                <div className="img-container">
                    <img
                        src={MC}
                        alt="Color Cube Match"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={3}>
            <Link to="/ds">
                <div className="img-container">
                    <img
                        src={DS}
                        alt="Brilliant Sort"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={2} hidden>
            <Link to="/fb">
                <div className="img-container">
                    <img
                        src={FE}
                        alt="Funky Bay"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={2}>
            <Link to="/sc">
                <div className="img-container gs">
                    <img
                        src={SC}
                        alt="Solitaire Cruise"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={2}>
            <Link to="/ba">
                <div className="img-container gs">
                    <img
                        src={PF}
                        alt="Bermuda Adventures"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
        <Grid size={2}>
            <Link to="/rt">
                <div className="img-container gs">
                    <img
                        src={RT}
                        alt="Roger That"
                        className="img-content"
                    />
                </div>
            </Link>
        </Grid>
    </Grid>
)

export default GamesList
